import { Helmet } from 'react-helmet-async';

/**
 * DocumentHead is a component that renders the head of the document.
 * It is used to set SEO-specific tags for the page.
 *
 * @param title - The title of the page.
 * @param description - The description of the page.
 * @returns A React component that renders the head of the document.
 */
const DocumentHead = ({ title, description }: { title: string; description: string }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
};

export default DocumentHead;
